import React from 'react';
import SVGLoader from './SVGLoader';

const CirclePauseIcon = ({ ...rest }) => {
  return (
    <SVGLoader viewboxHeight={40} viewboxWidth={40} {...rest}>
      <circle cx="20" cy="20" r="20" fill="currentColor" fillOpacity="0.5" />
      <path
        d="M13.75 10.8333H17.0833C17.0833 10.8333 18.3333 10.8333 18.3333 12.0833V27.9167C18.3333 27.9167 18.3333 29.1667 17.0833 29.1667H13.75C13.75 29.1667 12.5 29.1667 12.5 27.9167V12.0833C12.5 12.0833 12.5 10.8333 13.75 10.8333Z"
        fill="currentColor"
      />
      <path
        d="M22.9167 10.8333H26.2501C26.2501 10.8333 27.5001 10.8333 27.5001 12.0833V27.9167C27.5001 27.9167 27.5001 29.1667 26.2501 29.1667H22.9167C22.9167 29.1667 21.6667 29.1667 21.6667 27.9167V12.0833C21.6667 12.0833 21.6667 10.8333 22.9167 10.8333Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default CirclePauseIcon;
